import React, { useState } from 'react';
import { MuscleMap } from './MuscleMap';

const T = {
  es: { title: 'Mapa muscular', week: '7 días', month: '4 semanas', workouts: 'sesiones', shareWeek: 'Mi semana de entrenamiento', shareMonth: 'Mis últimas 4 semanas' },
  en: { title: 'Muscle map', week: '7 days', month: '4 weeks', workouts: 'workouts', shareWeek: 'My training week', shareMonth: 'My last 4 weeks' },
};

export const MuscleHeatmapCard = ({ clientId, language = 'es', defaultDays = 7, title, className = '' }) => {
  const t = T[language] || T.es;
  const [days, setDays] = useState(defaultDays);
  const [count, setCount] = useState(null);
  const today = new Date().toLocaleDateString(language === 'en' ? 'en-GB' : 'es-ES', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <div className={`glass-card p-4 ${className}`} data-testid="muscle-heatmap-card">
      <div className="flex items-center justify-between gap-2 mb-3 flex-wrap">
        <h3 className="text-white font-semibold text-base flex items-center gap-2">
          💪 {title || t.title}
          {count !== null && <span className="text-xs text-gray-400 font-normal" data-testid="muscle-heatmap-count">{count} {t.workouts}</span>}
        </h3>
        <div className="flex gap-1" data-testid="muscle-heatmap-range">
          {[[7, t.week], [28, t.month]].map(([d, label]) => (
            <button
              key={d}
              type="button"
              onClick={() => setDays(d)}
              data-testid={`muscle-heatmap-range-${d}`}
              className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${days === d ? 'bg-red-600 text-white' : 'bg-white/10 text-gray-300 hover:bg-white/20'}`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <MuscleMap
        key={days}
        clientId={clientId}
        days={days}
        language={language}
        shareable
        shareTitle={days === 7 ? t.shareWeek : t.shareMonth}
        shareDate={today}
        onData={(d) => setCount(d?.workouts_count ?? 0)}
      />
    </div>
  );
};

export default MuscleHeatmapCard;
